module.exports = __webpack_public_path__ + "img/w-cloud_devices.144b3c2e.png";